import { getSchemeForDc } from '@/services/distribution/ProcessingScheme';
import {
  adjAllocateQty, allocateInfo,
  finish,
  getProcessWave,
  page,
  queryProcessWaveRaw,
  saveProcessWave,
  saveProcessWaveRaw,
  skip,
  submit,
  switchStore,
  verifyContainer,
  verifyUnAllocateStore
} from '@/services/forward/out/ProcessWave';
import { hpcSubtr } from "@/utils/HpcCalculate";
import { formatMessage } from 'umi/locale';
export default {
  namespace: 'processWave',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.payload && location.pathname == "/out/processWave") {
          dispatch({
            type: 'showPage',
            payload: location.payload,
          })
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    rawRecords: {
      list: [],
      pagination: {}
    },
    stock: {
      list: [],
      pagination: {},
    },
    allocates: {
      stores: [],
      totalStoreCount: 0,
      unAllocateStoreCount: 0,
      totalQty: 0,
      unAllocateTotalQty: 0,
    },
    allocateStore: {
      store: {},
      qty: 0,
      caseQtyStr: 0,
      realQty: 0,
      realCaseQtyStr: 0,
    },
    endProduct: {},
    processScheme: {},
    entity: {},
    showPage: 'query',
  },
  effects: {
    *page({ payload, callback }, { call, put }) {
      const response = yield call(page, payload);
      yield put({
        type: 'save',
        payload: {
          list: response.data.records ? response.data.records : [],
          pagination: {
            total: response.data.paging.recordCount,
            pageSize: response.data.paging.pageSize,
            current: response.data.page + 1,
            showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
          },
        }
      })
      if (callback) callback(response);
    },

    *finish({ payload, callback }, { call, put }) {
      const response = yield call(finish, payload);
      if (callback) callback(response);
    },

    *saveWave({ payload, callback }, { call, put }) {
      const response = yield call(saveProcessWave, payload);
      if (callback) callback(response);
    },

    *saveWaveRaw({ payload, callback }, { call, put }) {
      const response = yield call(saveProcessWaveRaw, payload);
      if (callback) callback(response);
    },

    *get({ payload, callback }, { call, put }) {
      const response = yield call(getProcessWave, payload);
      if (response && response.success) {
        let response2;
        if (response.data) {
          response2 = yield call(getSchemeForDc, response.data.processScheme.uuid)
        }
        yield put({
          type: 'getProcessWaveBill',
          processScheme: response2 ? response2.data : {},
          entity: response.data ? response.data : {}
        })
      }
      if (callback) callback(response);
    },

    *getProcessScheme({ payload, callback }, { call, put }) {
      const response = yield call(getByUuid, payload);
      if (response && response.success) {
        yield put({
          type: 'processScheme',
          processScheme: response.data
        })
      }
      if (callback) callback(response);
    },

    *queryAllocateInfo({ payload, endProduct, callback }, { call, put }) {
      const response = yield call(allocateInfo, payload);
      if (response && response.success) {
        let allocateStoreArray = [];
        let unAllocateStoreCount = 0;
        let totalQty = 0;
        let unAllocateQty = 0;

        let defaultAllocateStore = undefined;
        if (response.data) {
          for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index];
            if (element.defaultStore && element.defaultStore === true) {
              defaultAllocateStore = element;
            }
            if ("FINISH" !== element.state) {
              unAllocateStoreCount++;
            }

            totalQty = totalQty + element.planQty;
            unAllocateQty = unAllocateQty + (hpcSubtr(element.planQty, element.allocateQty) > 0 ?
              hpcSubtr(element.planQty, element.allocateQty) : 0);

            allocateStoreArray.push(element);
          }
        }

        yield put({
          type: 'saveAllocate',
          allocate: {
            stores: allocateStoreArray,
            totalStoreCount: allocateStoreArray.length,
            unAllocateStoreCount: unAllocateStoreCount,
            totalQty: totalQty,
            unAllocateTotalQty: unAllocateQty,
          },
          allocateStore: defaultAllocateStore || {
            store: {},
            qty: 0,
            caseQtyStr: 0,
            realQty: 0,
            realCaseQtyStr: 0,
          },
          endProduct: endProduct,
        })
      }
      if (callback) callback(response);
    },

    *queryRaws({ payload, callback }, { call, put }) {
      const response = yield call(queryProcessWaveRaw, payload);
      if (response.success) {
        yield put({
          type: 'saveStock',
          payload: {
            list: response.data ? response.data : [],
          },
        });
      }
      if (callback) callback(response);
    },

    *switchStore({ payload }, { call, put }) {
      yield put({
        type: 'switchAllocate',
        allocateStore: payload.switchAllocateStore,
      });
    },

    *clearStore({ payload }, { call, put }) {
      yield put({
        type: 'clearAllocate',
      });
    },

    *submit({ payload, callback }, { call, put }) {
      const response = yield call(submit, payload);
      if (callback) callback(response);
    },
    *verifyContainerBarCode({ payload, callback }, { call, put }) {
      const response = yield call(verifyContainer, payload);
      if (callback) callback(response);
    },
    *verifyUnAllocateStore({ payload, callback }, { call, put }) {
      const response = yield call(verifyUnAllocateStore, payload);
      if (callback) callback(response);
    },
    *switchAllocateStore({ payload, endProduct, callback }, { call, put }) {
      const response = yield call(switchStore, payload);
      if (response && response.success) {
        let allocateStoreArray = [];
        let unAllocateStoreCount = 0;
        let totalQty = 0;
        let unAllocateQty = 0;

        let defaultAllocateStore;
        if (response.data) {
          for (let index = 0; index < response.data.length; index++) {
            const element = response.data[index];
            if (element.defaultStore && element.defaultStore === true) {
              defaultAllocateStore = element;
            }
            if ("FINISH" !== element.state) {
              unAllocateStoreCount++;
            }
            totalQty = totalQty + element.planQty;
            unAllocateQty = unAllocateQty + (hpcSubtr(element.planQty, element.allocateQty) > 0 ?
              hpcSubtr(element.planQty, element.allocateQty) : 0);

            allocateStoreArray.push(element);
          }
        }

        yield put({
          type: 'saveAllocate',
          allocate: {
            stores: allocateStoreArray,
            totalStoreCount: allocateStoreArray.length,
            unAllocateStoreCount: unAllocateStoreCount,
            totalQty: totalQty,
            unAllocateTotalQty: unAllocateQty,
          },
          allocateStore: defaultAllocateStore,
          endProduct: endProduct,
        })
      }
      if (callback) callback(response);
    },
    *skip({ payload, callback }, { call, put }) {
      const response = yield call(skip, payload);
      if (callback) callback(response);
    },
    *adjAllocateQty({ payload, callback }, { call, put }) {
      const response = yield call(adjAllocateQty, payload);
      if (callback) callback(response);
    },
    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        billNumber: payload.billNumber
      });
    },
    *clearStoreAllocateInfo({ payload }, { call, put }) {
      yield put({
        type: 'saveAllocate',
        allocate: {
          stores: [],
          totalStoreCount: 0,
          unAllocateStoreCount: 0,
          totalQty: 0,
          unAllocateTotalQty: 0,
        },
        endProduct: {},
        allocateStore: {
          store: {},
          qty: 0,
          caseQtyStr: 0,
          realQty: 0,
          realCaseQtyStr: 0,
        },
      })
    }
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    getProcessWaveBill(state, action) {
      return {
        ...state,
        entity: action.entity,
        processScheme: action.processScheme,
      };
    },
    processScheme(state, action) {
      return {
        ...state,
        processScheme: action.processScheme,
      };
    },
    saveStock(state, action) {
      return {
        ...state,
        stock: action.payload,
      };
    },

    saveAllocate(state, action) {
      return {
        ...state,
        allocates: action.allocate,
        allocateStore: action.allocateStore,
        endProduct: action.endProduct,
      };
    },

    switchAllocate(state, action) {
      return {
        ...state,
        allocateStore: action.allocateStore,
      };
    },

    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        billNumber: action.billNumber
      }
    },
    clearAllocate(state, action) {
      return {
        ...state,
        data: {
          list: [],
          pagination: {},
        },
        rawRecords: {
          list: [],
          pagination: {}
        },
        stock: {
          list: [],
          pagination: {},
        },
        allocates: {
          stores: [],
          totalStoreCount: 0,
          unAllocateStoreCount: 0,
          totalQty: 0,
          unAllocateTotalQty: 0,
        },
        allocateStore: {
          store: {},
          qty: 0,
          caseQtyStr: 0,
          realQty: 0,
          realCaseQtyStr: 0,
        },
        endProduct: {},
        processScheme: {},
        entity: {},
        showPage: 'query',
      }
    }
  }
}
